module.exports = __webpack_public_path__ + "media/Pika-3.c14c28e7.mp4";